import { css } from '@compiled/react';
import { graphql, type PreloadedQuery, usePreloadedQuery } from 'react-relay';

import type { codeFrame_loadFlowQuery } from './__generated__/codeFrame_loadFlowQuery.graphql';

type CodeFrameProps = {
	queryRef: PreloadedQuery<codeFrame_loadFlowQuery>;
};

export const CodeFrame = ({ queryRef }: CodeFrameProps) => {
	const data = usePreloadedQuery<codeFrame_loadFlowQuery>(
		graphql`
			query codeFrame_loadFlowQuery($sessionId: ID!, $cloudId: ID!) {
				devai_flowSessionGetByIDAndCloudID(sessionId: $sessionId, cloudId: $cloudId)
					@optIn(to: "DevAiFlowSessionGetByIDAndCloudID") {
					id
					createdAt
					issueARI
					pipelines {
						status
						url
					}
				}
			}
		`,
		queryRef,
	);

	if (!data?.devai_flowSessionGetByIDAndCloudID?.pipelines?.[0]?.url) {
		return null;
	}

	return (
		<iframe
			title="Flow"
			allow="clipboard-read; clipboard-write"
			src={data?.devai_flowSessionGetByIDAndCloudID?.pipelines?.[0]?.url}
			width="100%"
			height="100%"
			css={iframeStyles}
		/>
	);
};

const iframeStyles = css({
	border: 'none',
});
